import { createContext } from 'react'

import { Locale, defaultLocale } from './types'

const context = createContext<{
  locale: Locale
}>({ locale: defaultLocale })

export default context
